import React from "react";
import { Tabs } from "antd";

const { TabPane } = Tabs;

const ChartTypeMenu = ({ chartType, setChartType }) => {
  return (
    <Tabs
      activeKey={chartType}
      onChange={setChartType}
      centered={true}
    >
      <TabPane tab="Allocations Over Time" key="indices" />
      <TabPane tab="Detailed Breakdown" key="table" />
    </Tabs>
  );
};

export default ChartTypeMenu;
